import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const SyntraMfgHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Learning & Literacy");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/syntramfg");
  };

  const handleNavigate = (role) => {
    navigate("/syntramfg-enroll", { state: { selectedRole: role } });
  };

  const groupNames = [
    { label: "Learning & Literacy", emoji: "📚" },
    { label: "SOPHub", emoji: "🌉" },
    { label: "POHub", emoji: "🌉" },
    { label: "PehchaanSetu", emoji: "🌉" },
    { label: "Rankings", emoji: "🏆" },
    { label: "Jobs & AI", emoji: "🤖" },
    { label: "Supply Chain", emoji: "📦" },
    { label: "Roles", emoji: "👤" },
    { label: "Operations", emoji: "🏭" },
    { label: "Utilities", emoji: "⚙️" },
    { label: "Community", emoji: "🤝" },
    { label: "Earnings & Fun", emoji: "💰" },
  ];

  const roles = [
    "🏭 Plant Regional Co-ordinator",
    "📍Area Co-ordinator",
    "🔗Cluster Co-ordinator",
    "⚙️ Manufacturer",
    "🏆Think5Whys Aggregator (Self Employment)",
    "👷‍♂️Factory Workers",
    "📦Raw Material Supplier",
    "🏬Distributor / Dealer",
    "🛒Retailer / Showroom",
    "🚚Logistics Provider",
    "📦Warehouse & Storage",
    "🌐Export-Import Partner",
    "🛠️OEM (Original Equipment Manufacturer)",
    "🔧Maintenance & Service Provider",
    "🤝Industry Association / NGO",
    "🏢Corporate / Enterprise Buyer",
    "📚Manufacturing Scholar / Researcher",
    "🤖Robotics & Automation Specialist",
    "🧑‍🔬Process Expert / Consultant",
    "📊Quality & Compliance Auditor",
  ];

  const menuButtons1 = [
    // Learning & Literacy
    { label: "Monthly Literacy", emoji: "💻", link: "/syntramfg-bookworld", group: "Learning & Literacy" },
    { label: "Manufacturing Innovations", emoji: "💡", link: "/syntramfg-innovationhub", group: "Learning & Literacy" },
    { label: "Manufacturer Digital Card", emoji: "🪪", link: "/contact-genious/manufacturer", group: "Learning & Literacy" },
    { label: "My Monthly Sector Literacy", emoji: "📚", link: "/syntramfg-bookshelf", group: "Learning & Literacy" },

    // SOPHub 
    { label: "SOPHub", emoji: "🔗", link: "/sophub", group: "SOPHub" },
    
    // POHub 
    { label: "POHub", emoji: "🔗", link: "/pohub", group: "POHub" },

    // PehchaanSetu 
    { label: "PehchaanSetu", emoji: "🔗", link: "/pehchaansetu", group: "PehchaanSetu" },

    // Rankings
    { label: "SAKSHAM Udyam Ranking", emoji: "🏅", link: "/udyampragatiscore", group: "Rankings" },
    { label: "Winners", emoji: "🏆", link: "/syntramfgdb", group: "Rankings" },

    // Jobs & AI
    { label: "Blue Collar Jobs", emoji: "👨‍🌾", link: "/bluehands-home", group: "Jobs & AI" },
    { label: "AI Counselling", emoji: "🤖", link: "/aicounselling-about", group: "Jobs & AI" },

    // Supply Chain
    { label: "Product Search", emoji: "🔍", link: "/orderflow-products", group: "Supply Chain" },
    { label: "Packaging", emoji: "📦", link: "/syntramfg-packaging", group: "Supply Chain" },
    { label: "Logistics", emoji: "🚚", link: "/syntramfg-logistics", group: "Supply Chain" },
    { label: "Export-Import", emoji: "🚢", link: "/syntramfg-exportimport", group: "Supply Chain" },
    { label: "Metaverse", emoji: "🌐", link: "/syntramfg-metaverse", group: "Supply Chain" },
    { label: "Industrial Products", emoji: "⚙️", link: "/orderflow-products", group: "Supply Chain" },
    { label: "Consumer Goods", emoji: "🛍️", link: "/orderflow-products", group: "Supply Chain" },
    { label: "Auto Components", emoji: "🚗", link: "/orderflow-products", group: "Supply Chain" },
    { label: "Electronics", emoji: "📱", link: "/orderflow-products", group: "Supply Chain" },
    { label: "Maharashtra", emoji: "🇮🇳", link: "/orderflow-products", group: "Supply Chain" },
    { label: "Gujarat", emoji: "🇮🇳", link: "/orderflow-products", group: "Supply Chain" },
    { label: "Tamil Nadu", emoji: "🇮🇳", link: "/orderflow-products", group: "Supply Chain" },

    // Roles
    ...roles.map((role) => ({
      label: role.substring(role.indexOf(" ") + 1),
      emoji: role.split(" ")[0],
      link: "/syntramfg-enroll",
      group: "Roles",
      isRole: true,
    })),

    // Operations
    { label: "Contract Manufacturing", emoji: "🤝", link: "/syntramfg-contractmanufacturing", group: "Operations" },
    { label: "Products", emoji: "📦", link: "/orderflow-products", group: "Operations" },
    { label: "Services", emoji: "🛠️", link: "/think-service-home", group: "Operations" },
    { label: "Rental", emoji: "🏠", link: "/think-rent-home", group: "Operations" },
    { label: "Enquiry", emoji: "📩", link: "/syntramfg-leads", group: "Operations" },
    { label: "Complaints", emoji: "⚠️", link: "/syntramfg-complaints", group: "Operations" },
    { label: "Equipment and Assets", emoji: "🏭", link: "/syntramfg-assets", group: "Operations" },

    // Utilities
    { label: "Daily Life", emoji: "🏭", link: "/life-chronicles-home", group: "Utilities" },
    { label: "Diary", emoji: "📓", link: "/mydiary-home", group: "Utilities" },
    { label: "Attendance", emoji: "🕒", link: "/chronocheck-home", group: "Utilities" },
    { label: "Loan", emoji: "💰", link: "/syntramfg-loan", group: "Utilities" },
    { label: "Insurance", emoji: "🛡️", link: "/syntramfg-insurance", group: "Utilities" },
    { label: "Manufacturer Games", emoji: "🎮", link: "/syntramfg-games", group: "Utilities" },

    // Community
    { label: "Events", emoji: "🎪", link: "/event-flow-home", group: "Community" },
    { label: "Workshop", emoji: "📚", link: "/training-workshops", group: "Community" },
    { label: "Podcast", emoji: "🎙️", link: "#", group: "Community" },
    { label: "POV / Debate", emoji: "⚖️", link: "/povify-home", group: "Community" },
    { label: "Immersive Presentations", emoji: "🖼️", link: "/visualbrief-home", group: "Community" },

    // Earnings & Fun
    { label: "Refer", emoji: "🔗", link: "/orderflow-earning-estimator", group: "Earnings & Fun" },
    { label: "Resell", emoji: "♻️", link: "/syntramfg-enroll", group: "Earnings & Fun" },
    { label: "Rewarding Ads", emoji: "🎁", link: "/visigift-home", group: "Earnings & Fun" },
    { label: "Rewarding Videos", emoji: "🎥", link: "/orderflow-spotbuy", group: "Earnings & Fun" },
    { label: "Kharcho Jeeto", emoji: "💰", link: "/kharchojeeto", group: "Earnings & Fun" },
    { label: "Aalu Dalo Sona Nikalo", emoji: "🥔", link: "/aaludalosonanikalocomingsoon", group: "Earnings & Fun" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  const features = [
    {
      emoji: "🔗",
      title: "Real-Time Collaboration",
      desc: "Secure sharing and commenting on 3D models and data fields for seamless team coordination.",
    },
    {
      emoji: "📊",
      title: "Data-Driven Insights",
      desc: "Access real-time analytics to optimize manufacturing processes and decision-making.",
    },
    {
      emoji: "💬",
      title: "In-Context Messaging",
      desc: "Communicate directly within projects, documents, and simulations to boost productivity.",
    },
    {
      emoji: "🛠️",
      title: "Process Integration",
      desc: "Integrate engineering, design, and business processes for end-to-end efficiency.",
    },
    {
      emoji: "🎓",
      title: "Knowledge Sharing",
      desc: "Leverage expert insights to train and empower the manufacturing workforce.",
    },
    {
      emoji: "⚙️",
      title: "Simulation Tools",
      desc: "Simulate production scenarios to minimize risks and maximize outcomes.",
    },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-cyan-300">🏭 SyntraMfg</div>
          <div className="text-[11px] text-white">Synchronised Transformation in Manufacturing</div>
          <div className="text-[10px] text-yellow-200">The Future of Manufacturing, Today!</div>
        </div>

        {/* Desktop user controls */}
        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-cyan-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                Login
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-2xl text-cyan-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-cyan-300 text-xs font-medium">{userName}</div>
              <div className="flex gap-3">
                <button
                  onClick={handleLogout}
                  className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                >
                  ⏻
                </button>
              </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-cyan-300">Login</Link>
            </div>
          )}
        </div>
      )}

      {/* Top quick links */}
      <div className="bg-cyan-800 text-white text-xs sm:text-sm py-2">
        <div className="max-w-6xl mx-auto px-3 flex flex-wrap justify-center gap-4">
          <a href="/syntramfg-bookworld" className="hover:text-yellow-200">💻 Monthly Literacy</a>
          <a href="/syntramfg-innovationhub" className="hover:text-yellow-200">💡 Innovations</a>
          <a href="/contact-genious/manufacturer" className="hover:text-yellow-200">🪪 Digital Card</a>
          <a href="/syntramfg-about" className="hover:text-yellow-200">About</a>
          <Link to="/syntramfg-updates" className="hover:text-yellow-200">Updates</Link>
        </div>
      </div>

      {/* Tabs (categories) */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-2 border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs sm:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-cyan-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main content area with grid of buttons */}
      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-0 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => btn.isRole ? handleNavigate(`${btn.emoji} ${btn.label}`) : navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-2 py-1 rounded-md text-[10px] text-xs lg:text-sm font-medium transition bg-transparent hover:bg-cyan-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-xs lg:text-lsm">{btn.emoji}</span>
                <span className="mt-1 text-xs lg:text-sm">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-blue-400 text-white py-2">
        <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-cyan-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-cyan-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-cyan-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-cyan-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default SyntraMfgHome;